import * as Preact from 'preact';
import { SxProps } from '@mui/system';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';

export interface Props {
    statusText?: string;
    sx?: SxProps;
}

/** Represents a linear progress bar with optional status text beneath */
export const Component = (p: Props) => {
    return (
        <Box>
            <LinearProgress />
            {p.statusText && (
                <Typography textAlign="center" paddingTop="30px" variant={'body1'} sx={p.sx}>
                    {p.statusText}
                </Typography>
            )}
        </Box>
    );
};
